import { createContext, useContext } from 'react';
import type { CSSProperties, ReactElement } from 'react';
import type { DiscountByItemId } from '@wix/restaurants-normalizers';
import type { ShowcasePopulatedItem } from 'root/apiTypes';
import type { ImageResizeOptions } from 'wix-ui-tpa/cssVars';
import type { FeaturedBadgePlacement } from 'root/consts';

export type StyleProperties = CSSProperties & {
  [key: `--${string}`]: string | number | undefined;
};

export type ItemAction = {
  ariaLabel?: string;
  buttonStyle?: StyleProperties;
  fullWidth?: boolean;
  label: string;
  prefixIcon?: ReactElement;
  showLabel?: boolean;
  onClick: (item: ShowcasePopulatedItem) => Promise<void> | void;
};

export type ItemsBehavior = {
  action?: ItemAction;
  canPlaceFeaturedBadgeOnImage?: boolean;
  disableImageExpand?: boolean;
  featuredBadgePlacement?: FeaturedBadgePlacement;
  getItemClassName?: (item: ShowcasePopulatedItem) => string | undefined;
  hideModifierGroups?: boolean;
  hidePriceVariants?: boolean;
  imageResize?: ImageResizeOptions;
  showImagePlaceholder?: boolean;
};

type ContextType = {
  sectionId?: string;
  discountInfoByItemId?: DiscountByItemId;
  itemBehavior?: ItemsBehavior;
};

export const ItemsContext = createContext<ContextType>({});

export const ItemsContextProvider = ItemsContext.Provider;

export const useItemsContext = () => {
  const context = useContext(ItemsContext);
  if (!context) {
    throw new Error('useItemsContext must be used within an ItemsContextProvider');
  }
  return context;
};
